import { useSelector } from 'react-redux';
import { getPrivileges, getRequiredActions } from './index';

export const usePrivileges = () => useSelector(getPrivileges);
export const useRequiredActions = () => useSelector(getRequiredActions);
